"use strict";
var allSelectors = ".logo, .aside-link, .icon-cros";
var elements = document.querySelectorAll(allSelectors);
var burger = document.querySelector(".icon-burger");
var phone = document.querySelector(".icon-phone");
phone.addEventListener("mouseenter", function() {
    document.querySelector(".phone-number").classList.remove("displey-none");
});
phone.addEventListener("click", function() {
    document.querySelector(".phone-number").classList.add("displey-none");
});
burger.addEventListener("click", function() {
    document.body.classList.add("no-scroll");
});
elements.forEach(function(el) {
    el.addEventListener("click", function() {
        document.body.classList.remove("no-scroll");
    });
});

//# sourceMappingURL=index.65b0e1de.js.map
